<div class="feature-flag-dashboard">
  <h2>Router Migration Feature Flags</h2>

  <div class="dashboard-header">
    <div class="migration-progress">
      <h3>Migration Progress: {{ migrationProgress | number:'1.0-0' }}%</h3>
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="migrationProgress"></div>
      </div>
    </div>

    <div class="dashboard-actions">
      <button class="btn btn-secondary" (click)="resetToDefaults()">Reset to Defaults</button>
      <button class="btn btn-primary" (click)="exportConfiguration()">Export Config</button>
      <input type="file" #fileInput (change)="importConfiguration($event)" accept=".json" style="display: none;">
      <button class="btn btn-primary" (click)="fileInput.click()">Import Config</button>
    </div>
  </div>

  <!-- Migration Phases -->
  <div class="migration-phases">
    <h3>Migration Phases</h3>
    <div class="phases-grid">
      @for (phase of migrationPhases; track phase.phase) {
        <div class="phase-card"
             [class]="getPhaseStatus(phase.phase)"
             (click)="enablePhase(phase.phase)"
             (keydown.enter)="enablePhase(phase.phase)"
             (keydown.space)="enablePhase(phase.phase)"
             role="button"
             tabindex="0">
          <div class="phase-number">{{ phase.phase }}</div>
          <div class="phase-info">
            <div class="phase-name">{{ phase.name }}</div>
            <div class="phase-description">{{ phase.description }}</div>
          </div>
          <div class="phase-status">
            <span class="status-indicator" [class]="getPhaseStatus(phase.phase)"></span>
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Feature Flag Categories -->
  <div class="flag-categories">
    @for (category of flagCategories; track category.name) {
      <div class="flag-category">
        <div class="category-header">
          <h3>{{ category.name }}</h3>
          <div class="category-summary">
            {{ getFlagCount(category).enabled }} / {{ getFlagCount(category).total }} enabled
          </div>
        </div>

        <div class="flags-grid">
          @for (flag of category.flags; track flag.key) {
            <div class="flag-card">
              <div class="flag-header">
                <label class="flag-toggle">
                  <input type="checkbox"
                         [checked]="getFlagValue(flag.key)"
                         (change)="toggleFlagByKey(flag.key)">
                  <span class="toggle-slider"></span>
                </label>
                <div class="flag-info">
                  <div class="flag-label">{{ flag.label }}</div>
                  <div class="flag-description">{{ flag.description }}</div>
                </div>
              </div>

              <!-- Router type indicator for router migration flags -->
              @if (flag.key.includes('Router') && flag.key !== 'useAngularRouter') {
                <div class="flag-status">
                  <span class="router-type"
                        [class.angular]="getFlagValue(flag.key)"
                        [class.ui-router]="!getFlagValue(flag.key)">
                    {{ getFlagValue(flag.key) ? 'Angular Router' : 'UI-Router' }}
                  </span>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>

  <!-- Quick Actions -->
  <div class="quick-actions">
    <h3>Quick Actions</h3>
    <div class="actions-grid">
      @for (phase of migrationPhases; track phase.phase; let i = $index) {
        <button class="action-btn phase-btn"
                (click)="enablePhase(i)"
                [disabled]="getPhaseStatus(i) === 'completed'">
          <div class="action-icon">{{ i }}</div>
          <div class="action-text">
            <div class="action-title">Enable Phase {{ i }}</div>
            <div class="action-desc">{{ phase.name }}</div>
          </div>
        </button>
      }
    </div>
  </div>

  <!-- Current Status -->
  <div class="current-status">
    <h3>Current Router Configuration</h3>
    <div class="status-grid">
      <div class="status-item">
        <div class="status-label">Authentication</div>
        <div class="status-value" [class]="getCurrentRouterType('auth')">
          {{ getCurrentRouterType('auth') | titlecase }}
        </div>
      </div>
      <div class="status-item">
        <div class="status-label">Network</div>
        <div class="status-value" [class]="getCurrentRouterType('network')">
          {{ getCurrentRouterType('network') | titlecase }}
        </div>
      </div>
      <div class="status-item">
        <div class="status-label">Dashboard</div>
        <div class="status-value" [class]="getCurrentRouterType('dashboard')">
          {{ getCurrentRouterType('dashboard') | titlecase }}
        </div>
      </div>
      <div class="status-item">
        <div class="status-label">Profile</div>
        <div class="status-value" [class]="getCurrentRouterType('profile')">
          {{ getCurrentRouterType('profile') | titlecase }}
        </div>
      </div>
      <div class="status-item">
        <div class="status-label">Admin</div>
        <div class="status-value" [class]="getCurrentRouterType('admin')">
          {{ getCurrentRouterType('admin') | titlecase }}
        </div>
      </div>
      <div class="status-item">
        <div class="status-label">Workflows</div>
        <div class="status-value" [class]="getCurrentRouterType('workflows')">
          {{ getCurrentRouterType('workflows') | titlecase }}
        </div>
      </div>
      <div class="status-item">
        <div class="status-label">Contracts</div>
        <div class="status-value" [class]="getCurrentRouterType('contracts')">
          {{ getCurrentRouterType('contracts') | titlecase }}
        </div>
      </div>
      <div class="status-item">
        <div class="status-label">Signup</div>
        <div class="status-value" [class]="getCurrentRouterType('signup')">
          {{ getCurrentRouterType('signup') | titlecase }}
        </div>
      </div>
    </div>
  </div>
</div>